import React from "react";

// themePreference: "light" | "dark" | "system" (escolha do menu da conta).
const ColorModeContext = React.createContext({
    colorMode: {
        themePreference: "system",
        setThemePreference: () => {},
        toggleColorMode: () => {},
    },
});

export default ColorModeContext;
